import type { ISetupResponse } from '@booking-portal/types';
import type { IResponse } from '@booking-portal/types/api';
import { httpClient } from '@booking-portal/utils/fetch-utils';
import type { Maybe } from 'shared/types';

export function getSetupData(
  locationId?: Maybe<number>
): Promise<IResponse<ISetupResponse>> {
  const params = locationId ? { locationIds: locationId } : {};
  return httpClient
    .get<IResponse<ISetupResponse>>('/setup', { params })
    .then((response) => response.data);
}
